<template>
  <div>
    <BaseLine :text="$t('login.register.or')" v-if="isShowSocialConnector" />
    <div class="other-login-wrap">
      <!-- 除微信外其他登录方式 -->
      <div
        v-for="item in otherLoginLists"
        :key="item.name"
        class="other-login-item"
        @click="getLoginConfig"
        v-track="{ type: 'click', name: item.name }"
        :style="{ width: !isGuest ? '48%' : '100%' }"
      >
        <img :src="item.icon" alt="" v-if="item.name" />
      </div>
      <!-- 微信登录方式（需要在微信体系下显示） -->
      <!-- 后期如果微信要长显就可以直接合并到上面的数组中 -->
      <div
        class="other-login-item"
        @click="getLoginConfig(isWxBrowser ? 'wechat_mobile' : 'wechat_pc')"
        v-if="wxLogin && socialConnectorsWithWechat"
        v-track="{ type: 'click', name: `wechat` }"
        :style="{ width: !isGuest ? '48%' : '100%' }"
      >
        <img :src="img.wechat" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import wechat from '@/assets/images/common/weChat.svg'
import linkedin from '@/assets/images/common/LinkedIn.svg'
import BaseLine from '@/components/common/BaseLine'
import { getItem } from '@/utils/storage-main.js'
import { isGuest } from '@/utils/guest.js'
import { getBusinessType } from '@/constant'
export default {
  name: '',
  data() {
    return {
      img: {
        wechat,
        linkedin,
      },
      wxLogin: false,
      isWxBrowser: false,
      isPc: false,
    }
  },

  components: { BaseLine },

  computed: {
    isGuest() {
      return isGuest()
    },
    isDialog() {
      return this.$store.state.isDialog || false
    },
    socialConnectorsWithWechat() {
      return getBusinessType().socialConnectors.includes('wechat')
    },
    isShowSocialConnector() {
      if (this.wxLogin) {
        return getBusinessType().socialConnectors.length > 0 ? true : false
      }
      return this.otherLoginLists.length > 0 ? true : false
    },
    // 优化点： 根据数组内容显示对应登录组件
    otherLoginLists() {
      let connectors = []
      const currentSocialConnectors = getBusinessType().socialConnectors
      currentSocialConnectors.map((connector) => {
        connector !== 'wechat' &&
          connectors.push({
            name: connector,
            icon: this.img[connector],
          })
      })
      return connectors
    },
  },
  created() {
    this.ifWxLogin()
  },
  beforeMount() {},

  mounted() {
  },

  methods: {
    // 判断是否是手机浏览器
    checkMobileBrowser() {
      let check = false
      ;(function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },
    //判断是否可以用微信登录
    ifWxLogin() {
      let ua = navigator.userAgent.toLowerCase()
      //是微信浏览器
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.isWxBrowser = true
        //不是移动端
      } else if (!this.checkMobileBrowser()) {
        this.isPc = true
      }
      this.wxLogin = this.isWxBrowser || this.isPc
    },
    getLoginConfig(mode) {
      mode ? mode : this.isWxBrowser ? 'wechat_mobile' : 'wechat_pc'
      // snsapi_base 静默授权方式
      // snsapi_userinfo 非静默授权
      // 需要处理游客模式的回调地址
      let search = window.location.search ? window.location.search.slice(1) : ''
      let from = this.$route.path.includes('register') ? 'register' : 'login'
      let guestUrl = this.isGuest
        ? `guest=yes&redirect_url=${getItem('guestUrl')}`
        : ''
      const redirectUriMobile = encodeURIComponent(
        `${
          process.env.VUE_APP_REDIRECT_URI
        }/linkedin?type=${mode}&from=${from}${search ? `&${search}` : ''}${
          guestUrl ? `&${guestUrl}` : ''
        }`
      )
      const redirectUriPC = encodeURIComponent(
        `${
          process.env.VUE_APP_REDIRECT_URI
        }/linkedin?type=${mode}&from=${from}${search ? `&${search}` : ''}${
          guestUrl ? `&${guestUrl}` : ''
        }`
      )

      // const redirectUriLinkedin = encodeURIComponent(`${process.env.VUE_APP_REDIRECT_URI}/linkedin?type=${mode}&from=${from}&${search}`)
      const redirectUriLinkedin = `${
        process.env.VUE_APP_REDIRECT_URI
      }/linkedin?params=${window.btoa(
        `type=${mode}&from=${from}&${search}&${guestUrl}`
      )}`

      if (mode === 'wechat_mobile') {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_MOBIE_APPID}&redirect_uri=${redirectUriMobile}&channel=&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect`
        return false
      }
      let params = {
        mode,
        url: mode === 'linkedin' ? redirectUriLinkedin : redirectUriPC,
      }
      this.$api.login.GetAuthConfig(params).then(({ data }) => {
        window.location.href = data.url
        if (this.isDialog) {
          window.parent.postMessage({ loginType: 'weixin' }, '*')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.other-login-wrap {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  .other-login-item {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    cursor: pointer;
    width: 48%;
    height: 52px;
    justify-content: center;
  }
}
</style>
